// Central presentation helpers for enum values. Storage/API values are
// unchanged — this is display-only.
import { t } from "./i18n";

const LEVEL_I18N = {
  basic: "levelBasic",
  intermediate: "levelInter",
  advanced: "levelAdvanced",
};

const INDUSTRY_I18N = {
  retail: "industryRetail",
  hospital_cleaning: "industryHospitalClean",
  hospitality: "industryHospitality",
  restaurant: "industryRestaurant",
  call_center: "industryCallCenter",
  travel: "industryTravel",
  office: "industryOffice",
  warehouse_logistics: "industryWarehouseLogistics",
  healthcare_support: "industryHealthcareSupport",
  construction_trades: "industryConstructionTrades",
  landscaping: "industryLandscaping",
  other: "industryOther",
};

export const levelLabel = (lang, level) => {
  if (!level) return "—";
  const key = LEVEL_I18N[level];
  if (!key) return level;
  const label = t(lang, key);
  return label && label !== key ? label : level;
};

export const industryLabel = (lang, industry) => {
  if (!industry) return "—";
  const key = INDUSTRY_I18N[industry];
  if (!key) return industry;
  const label = t(lang, key);
  return label && label !== key ? label : industry;
};
